import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import { get, isInteger } from 'lodash';
import React from 'react';
import {
  Button,
  Form,
  OriCheckbox,
  OriNumberInput,
  RadioGroup,
  RadioItem,
  OriSelect as Select,
} from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import Section from 'src/pages/SalesCannelVersion/Components/SectionContainer';
import CollectionTable from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/CollectionTable';
import ProductTable from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/ProductTable';
import { maxMoney, maxTimes } from 'src/tools/constant';
import {
  isArray,
  isNumber,
  isNumberOrString,
  isString,
} from 'src/tools/helper';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import css from './css.module.less';

const Item = Form.Item;
const Option = Select.Option;
export enum EType {
  Value = 'Value',
  Count = 'Count',
}
export enum EProductsMatchRule {
  Any = 'Any',
  All = 'All',
}
export enum EApplyTo {
  All = 'All',
  Collections = 'Collections',
  Products = 'Products',
}

const Card = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };

  const {
    listName,
    fields,
    index,
    canDelete,
    form,
    onRemove,
    currency,
    disableEdit,
  } = props;
  // console.log('canDelete', canDelete);

  const nameListGenerate = (name) => {
    if (isArray(listName)) {
      return [...(listName || []), index, name];
    }
    if (isString(listName)) {
      return [listName, index, name];
    }
  };

  const getListValue = (data, key) => {
    const name = nameListGenerate(key);

    const v = get(data, name);
    return v;
  };

  const itemNamePrefix = fields[index]['name'];

  return (
    <Section bottomBorder>
      <Section className={css.innerSection} bottomBorder>
        <div className={css.sectionTitle}>
          <div className={css.title}>
            {getI18n(
              'salesChannelDirectDiscount.orderEligibleSection.orderEligibleCondition',
            )}{' '}
            {index + 1}
          </div>

          {canDelete && (
            <Button
              className={css.btn}
              onClick={onRemove}
              disabled={disableEdit}>
              {getI18n('general.remove')}
            </Button>
          )}
        </div>
        <Row
          elements={[
            {
              child: (
                <ItemWrapper title={getI18n('general.type')}>
                  <Item
                    rules={[{ required: true }]}
                    name={[itemNamePrefix, 'basedOn']}>
                    <Select size='large' disabled={disableEdit}>
                      <Option value={EType.Value}>
                        {getI18n(
                          'salesChannelDirectDiscount.eligibalCondition.orderamount',
                        )}
                      </Option>
                      <Option value={EType.Count}>
                        {getI18n(
                          'salesChannelDirectDiscount.eligibalCondition.quantityofitems',
                        )}
                      </Option>
                    </Select>
                  </Item>
                </ItemWrapper>
              ),
            },
            {
              child: <React.Fragment />,
            },
          ]}
        />
        <Item
          shouldUpdate={(p, c) => {
            const pV = getListValue(p, 'basedOn');
            const cV = getListValue(c, 'basedOn');

            return pV !== cV;
          }}>
          {({ getFieldValue }) => {
            setTimeout(() => {
              form.validateFields([
                nameListGenerate('maximum'),
                nameListGenerate('minimum'),
              ]);
            });
            const k = nameListGenerate('basedOn');
            const basedOn = getFieldValue(k);
            const frontNameGenerator = () => {
              if (basedOn === EType.Count) {
                return `${getI18n(
                  'salesChannelDirectDiscount.eligibalCondition.minimumQuantityofItems',
                )}* (>=)`;
              }
              if (basedOn === EType.Value) {
                return `${getI18n(
                  'salesChannelDirectDiscount.eligibalCondition.minimumOrderAmount',
                )}* (>=)`;
              }
              return '';
            };
            const rareNameGenerator = () => {
              if (basedOn === EType.Count) {
                return `${getI18n(
                  'salesChannelDirectDiscount.eligibalCondition.maximumQuantityofItems',
                )} (<)`;
              }
              if (basedOn === EType.Value) {
                return `${getI18n(
                  'salesChannelDirectDiscount.eligibalCondition.maximumOrderAmount',
                )} (<)`;
              }
              return '';
            };

            const suffixGenerator = () => {
              if (basedOn === EType.Count) {
                return '';
              }
              if (basedOn === EType.Value) {
                return currency || 'HKD';
              }
              return '';
            };
            if (basedOn === EType.Count) {
              return (
                <Row
                  elements={[
                    {
                      child: (
                        <ItemWrapper title={frontNameGenerator()}>
                          <Item
                            rules={[
                              {
                                validator: async (x, value) => {
                                  if (value && !isInteger(value)) {
                                    return Promise.reject(
                                      new Error(
                                        getI18n(
                                          'general.pleasefillavalidvalue',
                                        ),
                                      ),
                                    );
                                  }
                                  if (value < 1) {
                                    return Promise.reject(
                                      new Error(
                                        `${getI18n('general.noLessThan')} 1`,
                                      ),
                                    );
                                  }
                                },
                              },
                            ]}
                            name={[itemNamePrefix, 'minimum']}>
                            <OriNumberInput
                              size='large'
                              suffix={suffixGenerator()}
                              max={maxTimes}
                              min={0}
                              disabled={disableEdit}
                            />
                          </Item>
                        </ItemWrapper>
                      ),
                    },
                    {
                      child: (
                        <Item
                          shouldUpdate={(p, c) => {
                            const pV = getListValue(p, 'minimum');
                            const cV = getListValue(c, 'minimum');

                            // const pVmax = getListValue(p, 'maximum');
                            // const cVmax = getListValue(c, 'maximum');
                            return pV !== cV;
                          }}>
                          {({ getFieldValue }) => {
                            setTimeout(() => {
                              form.validateFields([
                                nameListGenerate('maximum'),
                              ]);
                            });
                            const k = nameListGenerate('minimum');
                            const minimum = getFieldValue(k);

                            return (
                              <ItemWrapper title={rareNameGenerator()}>
                                <Item
                                  rules={[
                                    {
                                      validator: async (x, value) => {
                                        // if (!isInteger(value)) {
                                        //   return Promise.reject(
                                        //     new Error(
                                        //       'Please fill a valid value',
                                        //     ),
                                        //   );
                                        // }

                                        if (
                                          isInteger(value) &&
                                          value < minimum
                                        ) {
                                          return Promise.reject(
                                            new Error(
                                              getI18n(
                                                'general.pleasefillavalidvalue',
                                              ),
                                            ),
                                          );
                                        }
                                      },
                                    },
                                  ]}
                                  name={[itemNamePrefix, 'maximum']}>
                                  <OriNumberInput
                                    size='large'
                                    placeholder={getI18n(
                                      'salesChannelDirectDiscount.eligibalCondition.nolimit',
                                    )}
                                    suffix={suffixGenerator()}
                                    max={maxTimes}
                                    min={0}
                                    disabled={disableEdit}
                                  />
                                </Item>
                              </ItemWrapper>
                            );
                          }}
                        </Item>
                      ),
                    },
                  ]}
                />
              );
            }
            if (basedOn === EType.Value) {
              return (
                <Row
                  elements={[
                    {
                      child: (
                        <ItemWrapper title={frontNameGenerator()}>
                          <Item
                            rules={[
                              {
                                validator: async (x, value) => {
                                  // console.log('value', value);
                                  // console.log(
                                  //   'isNumber(value)',
                                  //   isNumber(value),
                                  // );
                                  // console.log(
                                  //   'isInteger(value)',
                                  //   isInteger(value),
                                  // );

                                  if (value && !isNumberOrString(value)) {
                                    return Promise.reject(
                                      new Error(
                                        getI18n('general.pleasefillthisfield'),
                                      ),
                                    );
                                  }
                                  if (value <= 0) {
                                    return Promise.reject(
                                      new Error(
                                        replaceI18nVariables(
                                          getI18n(
                                            'general.valueshouldbegreaterthan',
                                          ),
                                          0,
                                        ),
                                      ),
                                    );
                                  }
                                },
                              },
                            ]}
                            name={[itemNamePrefix, 'minimum']}>
                            <OriNumberInput
                              //min={0}
                              size='large'
                              suffix={suffixGenerator()}
                              max={maxMoney}
                              precision={2}
                              min={0}
                              disabled={disableEdit}
                            />
                          </Item>
                        </ItemWrapper>
                      ),
                    },
                    {
                      child: (
                        <Item
                          shouldUpdate={(p, c) => {
                            const pV = getListValue(p, 'minimum');
                            const cV = getListValue(c, 'minimum');

                            // const pVmax = getListValue(p, 'maximum');
                            // const cVmax = getListValue(c, 'maximum');
                            return pV !== cV;
                          }}>
                          {({ getFieldValue }) => {
                            setTimeout(() => {
                              form.validateFields([
                                nameListGenerate('maximum'),
                              ]);
                            });
                            const k = nameListGenerate('minimum');
                            const minimum = getFieldValue(k);

                            return (
                              <ItemWrapper title={rareNameGenerator()}>
                                <Item
                                  rules={[
                                    {
                                      validator: async (x, value) => {
                                        if (
                                          isNumber(value) &&
                                          value < minimum
                                        ) {
                                          return Promise.reject(
                                            new Error(
                                              getI18n(
                                                'general.pleasefillavalidvalue',
                                              ),
                                            ),
                                          );
                                        }
                                      },
                                    },
                                  ]}
                                  name={[itemNamePrefix, 'maximum']}>
                                  <OriNumberInput
                                    size='large'
                                    placeholder={getI18n(
                                      'salesChannelDirectDiscount.eligibalCondition.nolimit',
                                    )}
                                    suffix={suffixGenerator()}
                                    max={maxMoney}
                                    min={0}
                                    precision={2}
                                    disabled={disableEdit}
                                  />
                                </Item>
                              </ItemWrapper>
                            );
                          }}
                        </Item>
                      ),
                    },
                  ]}
                />
              );
            }
            return null;
          }}
        </Item>
      </Section>
      <Section className={css.applyToContainer} bottomBorder>
        <ItemWrapper
          title={getI18n(
            'salesChannelGiftPurchase.customerGets.conditionAppliesTo',
          )}>
          <Item name={[itemNamePrefix, 'applyTo']}>
            <RadioGroup className={css.radioGroup} disabled={disableEdit}>
              <RadioItem value={EApplyTo.All} className={css.radio}>
                {getI18n('general.allProducts')}
              </RadioItem>
              <RadioItem value={EApplyTo.Collections} className={css.radio}>
                {getI18n(
                  'salesChannelDirectDiscount.discountValuebuyOne.specificCollections',
                )}
              </RadioItem>
              <AnyAllRadio
                name={[itemNamePrefix, 'matchRule']}
                getListValue={getListValue}
                dependencies={nameListGenerate('applyTo')}
                triggerName={EApplyTo.Collections}
                className={css.matchRuleGroup}
                disabled={disableEdit}
              />

              <RadioItem value={EApplyTo.Products}>
                {getI18n(
                  'salesChannelDirectDiscount.eligibalCondition.specificProducts',
                )}
              </RadioItem>
              <AnyAllRadio
                name={[itemNamePrefix, 'matchRule']}
                getListValue={getListValue}
                dependencies={nameListGenerate('applyTo')}
                triggerName={EApplyTo.Products}
                className={css.lastRadioGroup}
                disabled={disableEdit}
              />
            </RadioGroup>
          </Item>
        </ItemWrapper>
        <_ProductTable
          name={[itemNamePrefix, 'products']}
          getListValue={getListValue}
          dependencies={nameListGenerate('applyTo')}
          triggerName={EApplyTo.Products}
          disableEdit={disableEdit}
        />
        <_CollectionTable
          name={[itemNamePrefix, 'collections']}
          getListValue={getListValue}
          dependencies={nameListGenerate('applyTo')}
          triggerName={EApplyTo.Collections}
          disableEdit={disableEdit}
        />
      </Section>
      <Section className={css.checkboxContainer} bottomBorder>
        <Item
          name={[itemNamePrefix, 'flashSaleExcluded']}
          valuePropName={'checked'}>
          <OriCheckbox disabled={disableEdit}>
            {getI18n(
              'salesChannelDirectDiscount.discountValue.excludeflashsaleitems',
            )}
          </OriCheckbox>
        </Item>
      </Section>
    </Section>
  );
};
export default Card;

const _ProductTable = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { name, getListValue, dependencies, triggerName, disableEdit } = props;
  return (
    <Item
      shouldUpdate={(p, c) => {
        const pV = getListValue(p, 'applyTo');
        const cV = getListValue(c, 'applyTo');
        return pV !== cV;
      }}>
      {({ getFieldValue }) => {
        const v = getFieldValue(dependencies);
        if (v === triggerName) {
          return (
            <div className={css.tableContainer}>
              <Item
                name={name}
                rules={[
                  {
                    validator: async (x, value) => {
                      if ((value || []).length < 1) {
                        return Promise.reject(
                          new Error(
                            getI18n(
                              'general.advancedFilters.commonRadioMulSelect.selectItem',
                            ),
                          ),
                        );
                      }
                    },
                  },
                ]}>
                <ProductTable disableEdit={disableEdit} />
              </Item>
            </div>
          );
        }
        return null;
      }}
    </Item>
  );
};

const _CollectionTable = (props) => {
  const { name, getListValue, dependencies, triggerName, disableEdit } = props;
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  return (
    <Item
      shouldUpdate={(p, c) => {
        const pV = getListValue(p, 'applyTo');
        const cV = getListValue(c, 'applyTo');
        return pV !== cV;
      }}>
      {({ getFieldValue }) => {
        const v = getFieldValue(dependencies);
        if (v === triggerName) {
          return (
            <div className={css.tableContainer}>
              <Item
                name={name}
                rules={[
                  {
                    validator: async (x, value) => {
                      if ((value || []).length < 1) {
                        return Promise.reject(
                          new Error(
                            getI18n(
                              'general.advancedFilters.commonRadioMulSelect.selectItem',
                            ),
                          ),
                        );
                      }
                    },
                  },
                ]}>
                <CollectionTable disabled={disableEdit} />
              </Item>
            </div>
          );
        }
        return null;
      }}
    </Item>
  );
};

const AnyAllRadio = (props) => {
  const { name, getListValue, dependencies, triggerName, className, disabled } =
    props;

  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  return (
    <Item
      shouldUpdate={(p, c) => {
        const pV = getListValue(p, 'applyTo');
        const cV = getListValue(c, 'applyTo');
        return pV !== cV;
      }}>
      {({ getFieldValue }) => {
        const v = getFieldValue(dependencies);

        if (v === triggerName) {
          return (
            <Item
              name={name}
              rules={[{ required: true, message: 'Please Select a value' }]}>
              <RadioGroup
                className={`${css.radioGroup} ${className || ''}`}
                disabled={disabled}>
                <RadioItem value={EProductsMatchRule.All} className={css.radio}>
                  {getI18n('general.all')}
                </RadioItem>
                <RadioItem value={EProductsMatchRule.Any} className={css.radio}>
                  {getI18n('general.any')}
                </RadioItem>
              </RadioGroup>
            </Item>
          );
        }
        return null;
      }}
    </Item>
  );
};
